import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _noop from "lodash/noop";
import { Spinner } from '@datacamp/campus-integration';
import { SignupForm } from '@datacamp/le-shared-components';
import { Dialog } from '@datacamp/waffles-modals';
import * as React from 'react';
import config from '../config';
import spreadsheetsApiClient from '../lib/spreadsheetsApiClient';
import { jsx as ___EmotionJSX } from "@emotion/react";
class WaitForLogin extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      error: null,
      loggedIn: false
    });
  }
  async componentDidMount() {
    const {
      environment
    } = this.props;
    try {
      await spreadsheetsApiClient(environment).authenticate();
      this.setState({
        error: null,
        loggedIn: true
      });
    } catch (e) {
      this.setState({
        // @ts-expect-error fix later
        error: e,
        loggedIn: false
      });
    }
  }
  render() {
    const {
      error,
      loggedIn
    } = this.state;
    const {
      children,
      environment
    } = this.props;
    if (!loggedIn) {
      if (error !== null) {
        return ___EmotionJSX(Dialog, {
          hideCloseButton: true,
          isOpen: true,
          onClose: _noop,
          width: 600
        }, ___EmotionJSX(SignupForm, {
          datacampUrl: config(environment).urls.MAIN_APP
        }));
      }
      return ___EmotionJSX(Spinner, null);
    }
    return children;
  }
}
export default WaitForLogin;